import { KnmKindCodesEnum } from 'APIPackage/DictionariesModule/enums/KnmKindCodesEnum';
import {
  getResultDecisionAddressBlockId,
  getResultDecisionInnLabelBlockId,
  getResultDecisionOgrnLabelBlockId,
  getResultDecisionOrganizationNameBlockId,
  getResultDecisionOrganizationTemplateBlockId,
} from 'KnmErknmPackage/MainModule/constants/knmErknmFieldsElementsIds';
import { IKnmErknmOrganizationTemplateSelectOption } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmOrganizationTemplateSelectOption';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { ErknmSubjectAdd } from 'KnmErknmPackage/ErknmActsModule/components/ErknmPaperlessActComponents/components/ErknmActSubject/components/ErknmSubjectAdd';
import { IKnmErknmFormResultDecision } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormResultDecision';
import { ErknmSubjectAddDecision } from 'KnmErknmPackage/ErknmActsModule/components/ErknmPaperlessActComponents/components/ErknmActSubject/components/ErknmSubjectAddDecision';
import { KnmResultItemSubjectTypesEnum } from 'KnmErknmPackage/ErknmResultDecisionsModule/components/ErknmResultItemSubjectInfo';

import styles from './ResultDecisionsItemContentSubject.module.scss';

interface IResultDecisionsItemContentSubjectProps {
  id: string;
  kindKnmCode?: KnmKindCodesEnum;
  name: string;
  organizationsTemplatesSelectOptions: IKnmErknmOrganizationTemplateSelectOption[] | undefined;
  value: IKnmErknmFormResultDecision;
  isLater4111ForDecision: boolean;
}

export const ResultDecisionsItemContentSubject = ({
  id,
  kindKnmCode,
  name,
  organizationsTemplatesSelectOptions,
  value,
  isLater4111ForDecision,
}: IResultDecisionsItemContentSubjectProps) => {
  return (
    <div className={styles.Wrapper}>
      {value.organization?.subjectType?.code &&
      isLater4111ForDecision &&
      value.organization.subjectType.code === KnmResultItemSubjectTypesEnum.UR ? (
        <div className={styles.SubjectAdd}>
          <ErknmSubjectAddDecision
            id={id}
            watchOnly={true}
            kindKnmCode={kindKnmCode}
            organizationsTemplatesSelectOptions={organizationsTemplatesSelectOptions}
            name={name}
            organizationTemplate={value.organizationTemplate}
            organizationTemplateBlockId={getResultDecisionOrganizationTemplateBlockId(id)}
            inn={value.organization?.inn}
            innLabelBlockId={getResultDecisionInnLabelBlockId(id)}
            ogrn={value.organization?.ogrn}
            ogrnLabelBlockId={getResultDecisionOgrnLabelBlockId(id)}
            organizationNameBlockId={getResultDecisionOrganizationNameBlockId(id)}
            addressBlockId={getResultDecisionAddressBlockId(id)}
            checkSubjectResult={value.organization?.checkSubjectResult || null}
            isAutocomplete={value.organization?.isAutocomplete}
            subjectType={value.organization?.subjectType}
            kpp={value.organization?.kpp}
            smevRequestStatus={value.organization?.smevRequestStatus}
            rafpNza={value.organization?.rafpNza}
            snils={value.organization?.snils}
            ervkId={value.organization?.ervkId}
            valueForm={value}
            isShowSubjectInfoNow
            listId=""
          />
        </div>
      ) : (
        <>
          <FieldBlock label={'Сведения о контролируемом лице'} />
          <div className={styles.SubjectAdd}>
            <ErknmSubjectAdd
              id={id}
              watchOnly={true}
              kindKnmCode={kindKnmCode}
              organizationsTemplatesSelectOptions={organizationsTemplatesSelectOptions}
              name={name}
              organizationTemplate={value.organizationTemplate}
              organizationTemplateBlockId={getResultDecisionOrganizationTemplateBlockId(id)}
              inn={value.organization?.inn}
              innLabelBlockId={getResultDecisionInnLabelBlockId(id)}
              ogrn={value.organization?.ogrn}
              ogrnLabelBlockId={getResultDecisionOgrnLabelBlockId(id)}
              organizationNameBlockId={getResultDecisionOrganizationNameBlockId(id)}
              addressBlockId={getResultDecisionAddressBlockId(id)}
              checkSubjectResult={value.organization?.checkSubjectResult || null}
              isAutocomplete={value.organization?.isAutocomplete}
              subjectType={value.organization?.subjectType}
              kpp={value.organization?.kpp}
              smevRequestStatus={value.organization?.smevRequestStatus}
              rafpNza={value.organization?.rafpNza}
              snils={value.organization?.snils}
              ervkId={value.organization?.ervkId}
              isShowSubjectInfoNow
              listId=""
            />
          </div>
        </>
      )}
    </div>
  );
};
